import React, { useEffect, useRef, useState } from 'react'
import Theme1 from './Themes/Theme1/Theme1'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { getProfileDetail } from '../../redux/reducers/profileSlice'
import { getEventsById } from '../../redux/reducers/eventSlice'
import { snackbarContext } from '../helpers/Snakbar'
import { clearUser, getAuthProp } from '../../redux/reducers/authSlice'
import Loader from '../helpers/Loader'
import InviteExpired from './FinalOutput/InviteExpired'
import Theme2 from './Themes/Theme2/Theme2'
import Theme3 from './Themes/Theme3/Theme3'
import MusicNoteIcon from '@mui/icons-material/MusicNote';
import { TabTitle } from '../helpers/GeneralFunctions'
import Theme4 from './Themes/Theme4/Theme4'
import Theme5 from './Themes/Theme5/Theme5'


const ThemeRenderer = ({mode,demoId,photoControls,iconAnimate}) => {
  const audioRef = useRef(null);
   const [isMusicPlaying, setIsMusicPlaying] = useState(false);
   const params = useParams()
    const location = useLocation();
  //  let id = params.userId

  let id=""

  if(demoId){
    id=demoId
  }else{
    id=params.userId
  }




   const isPreview = mode === "preview";
    const isPublic=  mode === "public"
  const queryParams = new URLSearchParams(location.search);
  const group = queryParams.get('group');



  const dispatch=useDispatch()
  const navigate=useNavigate()
    const setStateSnackbarContext = React.useContext(snackbarContext)

  const { weddingData: data, loading: profileLoading,profileLoaded } = useSelector((state) => state.profile)
  const { events } = useSelector((state) => state.event)
  const {error:authError,loading: authLoading} = useSelector(state => state.auth);

      const [notFound,setNotFound]=useState(false)
       const [demoExpired,setDemoExpired]=useState(false)
       const [inviteExpired,setInviteExpired]=useState(false)

const isLoading = authLoading || profileLoading

const namesKnown =
  data.groomName !== "" &&
  data.brideName !== "";

const titleNames =
  data.displayOrder === "brideFirst"
    ? `${data.brideName} & ${data.groomName}`
    : `${data.groomName} & ${data.brideName}`;

TabTitle(
  namesKnown
    ? `${titleNames} - Wedding Invitation`
    : "Aamantran Wedding Invitation"
);


  
   useEffect(() => {
     dispatch(getAuthProp({id,setNotFound,setDemoExpired,setInviteExpired}))
      dispatch(getProfileDetail({ id, navigate, setStateSnackbarContext }))
      dispatch(getEventsById ({ id, group }))
    }, [id])

     useEffect(() => {
        const handleVisibilityChange = () => {
          if (document.hidden && audioRef.current) {
            audioRef.current.pause();
            setIsMusicPlaying(false);
          }
        };
      
        document.addEventListener("visibilitychange", handleVisibilityChange);
      
        return () => {
          document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
      }, []);
      
      useEffect(() => {
        return () => {
          if (audioRef.current) {
            audioRef.current.pause();
            audioRef.current.currentTime = 0;
          }
        };
      }, []);


       const playMusic = () => {
  if (!audioRef.current) return;
  audioRef.current
    .play()
    .then(() => {
      setIsMusicPlaying(true);
    })
    .catch((err) => {
      console.log("Audio play blocked:", err);
    });
};


 useEffect(() => {
          if (!profileLoaded) return;
      
          if ((isPreview || isPublic) && !data?.theme) {
              setStateSnackbarContext(
                  true,
                  "Please select Theme",
                  "warning"
              );
      
              navigate("/sample-themes");
          }
      }, [profileLoaded, data?.theme, navigate]);

const toggleMusic = () => {
  if (!audioRef.current) return;

  if (isMusicPlaying) {
    audioRef.current.pause();
    setIsMusicPlaying(false);
  } else {
    audioRef.current.play();
    setIsMusicPlaying(true);
  }
};


  

        if (authError === "session expired") {
              setStateSnackbarContext(true, "session expired please login again", "error");
              dispatch(clearUser())
              navigate("/login")
            }

             if(notFound){
        return  navigate("/display/notfound")
      }

   


      if(isLoading){
        return <Loader/>
      }

      if(inviteExpired){
        return <InviteExpired />
      }

      return (
    <>
      <audio
        ref={audioRef}
        src={data?.music?.audio?.url}
        preload="none"
        loop
      />


      {/* ================= THEME 1 ================= */}

      {data.theme === "theme1" && (

        <Theme1
          details={data}
          events={events}
          isPreview={isPreview}
          demoExpired={demoExpired}
          photoControls={photoControls}
          iconAnimate={iconAnimate}
          playMusic={playMusic}
          toggleMusic={toggleMusic}
          isMusicPlaying={isMusicPlaying}
        />

      )}


      {/* ================= THEME 2 ================= */}

      {data.theme === "theme2" && (

        <Theme2
          details={data}
          events={events}
          isPreview={isPreview}
          demoExpired={demoExpired}
          photoControls={photoControls}
            iconAnimate={iconAnimate}
          playMusic={playMusic}
          toggleMusic={toggleMusic}
          isMusicPlaying={isMusicPlaying}
        />

      )}


      {/* ================= THEME 3 ================= */}

      {data.theme === "theme3" && (

        <Theme3
          details={data}
          events={events}
          isPreview={isPreview}
          demoExpired={demoExpired}
          photoControls={photoControls}
           iconAnimate={iconAnimate}
          playMusic={playMusic}
          toggleMusic={toggleMusic}
          isMusicPlaying={isMusicPlaying}
        />

      )}

          {data.theme === "theme4" && (

        <Theme4
          details={data}
          events={events}
          isPreview={isPreview}
          demoExpired={demoExpired}
          photoControls={photoControls}
              iconAnimate={iconAnimate}
          playMusic={playMusic}
          toggleMusic={toggleMusic}
          isMusicPlaying={isMusicPlaying}
        />

      )}


        {data.theme === "theme5" && (

        <Theme5
          details={data}
          events={events}
          isPreview={isPreview}
          demoExpired={demoExpired}
          photoControls={photoControls}
         iconAnimate={iconAnimate}
          playMusic={playMusic}
          toggleMusic={toggleMusic}
          isMusicPlaying={isMusicPlaying}
        />

      )}

    </>
  );

       

  //     if(data.theme==="theme1"){
  //       return   <Theme1  details={data}  events={events}   isPreview={isPreview}  demoExpired={demoExpired} photoControls={photoControls}   />
  //     }

  //        if(data.theme==="theme2"){
  //       return  <Theme2   details={data}  events={events}  isPreview={isPreview}  demoExpired={demoExpired}  photoControls={photoControls} />
  //     }

  //        if(data.theme==="theme3"){
  //       return  <Theme3   details={data}  events={events}  isPreview={isPreview}  demoExpired={demoExpired}  photoControls={photoControls} />
  //     }

  // return null;
  
}

export default ThemeRenderer